const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class PhxDriverPaymentServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async getConnectedAccount(driverId) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/drivers/payments/${driverId}/connectedAccount`,
        method: 'GET',
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateConnectedAccount(driverId, options) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/drivers/payments/${driverId}/connectedAccount`,
        method: 'PUT',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getOnboardingLink(params) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/payments/onboarding-link`, { params });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getPublishableKey() {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/payments/publishable-key`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getWallet() {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/payments/wallet`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async addBankAccount(options) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/payments/bank-accounts`,
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async acceptTos() {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/payments/tos`,
        method: 'PUT',
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  PhxDriverPaymentServiceConnector,
};
